// config.js

const bizIcon = 'https://assets.cdn.filesafe.space/BzaX5UGHCmFDX5CfQFdo/media/676465e063c0fe2ba5d92612.png';
const myBizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const imageOne = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/BzaX5UGHCmFDX5CfQFdo/media/6765938dfb63bc370868ec7a.jpeg";
const imageTwo = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/BzaX5UGHCmFDX5CfQFdo/media/67659383fb63bc632d68ec5c.jpeg";
const imageThree = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/BzaX5UGHCmFDX5CfQFdo/media/67659d1d7e62114151ae24af.png";
const imageFour = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/BzaX5UGHCmFDX5CfQFdo/media/6765938d37faab5da0f07e8c.jpeg";
const imageFive = "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/BzaX5UGHCmFDX5CfQFdo/media/6765937f05c6f018f76fb82b.jpeg";

const redirectLink = "https://jmroofingremodelingllc.com/";

export const siteConfig = {
  title: "JM Roofing & Remodeling LLC",
  metaDescription: "JM Roofing & Remodeling LLC",
  theme: {
    primaryColor: "red-600",
    secondaryColor: "gray-900",
    accentColor: "text-red-600"
  },
  logo: {
    src: bizIcon,
    alt: "JM Roofing & Remodeling LLC Icon",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "JM Roofing & Remodeling LLC",
    headline: "Your Trusted Roofing & Remodeling Experts in Brockton, MA",
    address: "Brockton, Massachusetts",
    description: `
        JM Roofing & Remodeling LLC is your go-to partner for premier roofing and remodeling services in Brockton, MA, and surrounding areas. With extensive experience and a commitment to excellence, we specialize in roof installations, repairs, replacements, and comprehensive remodeling solutions. Our skilled team delivers quality craftsmanship and tailored services that enhance the durability and aesthetic appeal of your property. At JM Roofing & Remodeling LLC, customer satisfaction is our top priority, and we take pride in transforming your home or business into a space that stands the test of time. Trust us for reliable, top-tier roofing and remodeling services.
    `,
  },
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Roofing & Remodeling Experts in Brockton, MA",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
        description: 
          "Wide Range of Roofing Services: From installations and repairs to inspections and maintenance, we handle all your roofing needs with expertise. We work with various materials such as asphalt shingles, metal, tile, and flat roofing systems.",
    },
    {
        description: 
          "Professional Roof Assessments: Not sure if your roof needs a repair or replacement? Our thorough inspections identify issues such as leaks, missing shingles, or water damage. We provide clear recommendations to help you make informed decisions.",
    },
    {
        description: 
          "Timely and Efficient Service: Most residential roof installations or replacements are completed within 1–3 days, depending on project size and complexity. We prioritize minimizing disruptions while delivering quality results you can rely on.",
    },
  ],
  services: {
    sectionTitle: "Our Roofing and Remodeling Services",
    description: 
      "At JM Roofing & Remodeling LLC, we specialize in providing exceptional roofing, remodeling, and construction services tailored to your unique needs. From expert installations to comprehensive maintenance, our team is committed to delivering top-notch results that protect and enhance your property. Explore our diverse services and see why homeowners in Brockton, MA, and beyond trust us for their roofing and remodeling needs.",
    callouts: [
        {
          name: 'Roofing',
          description: 
            "Our team excels in professional roof installations using premium materials to ensure long-lasting durability and protection for your home or business.",
          imageSrc: imageTwo,
          imageAlt: 'A professional team installing a sturdy and modern roof on a residential property.',
        },
        {
          name: 'Remodeling',
          description: 
            "Transform your spaces with our expert remodeling services. From kitchens to bathrooms and beyond, we bring your vision to life with superior craftsmanship.",
          imageSrc: imageThree,
          imageAlt: 'A beautifully remodeled kitchen showcasing modern design and quality finishes.',
        },
        {
          name: 'Construction & Renovation Services',
          description: 
            "Enhance your property with our construction and renovation services, ensuring a seamless and efficient process from start to finish.",
          imageSrc: imageFour,
          imageAlt: 'A newly constructed residential space featuring sleek, modern architecture.',
        },
      ],
      otherServices: [
        "Exterior Services",
      ],
  },
  about: {
    sectionTitle: "About Us",
    description:   
      "Welcome to JM Roofing & Remodeling LLC, your trusted partner for all your construction and renovation needs. Based in Brockton, MA, we specialize in delivering exceptional construction, remodeling, and exterior services to enhance and protect your property. With years of expertise, our team is committed to quality craftsmanship and unparalleled customer satisfaction.\n\nWe understand the importance of a well-constructed home and expertly designed exteriors to elevate your property's value and aesthetic appeal. Our services are tailored to meet the unique needs of each client, ensuring durable results that stand the test of time. Whether you require comprehensive renovations, new construction, or exterior upgrades, JM Roofing & Remodeling LLC is here to provide reliable and cost-effective solutions.\n\nLet us bring your vision to life with unmatched professionalism and attention to detail. Trust JM Roofing & Remodeling LLC to transform your property into a space that reflects your style and meets your needs.",
    image: {
      src: imageFive,
      alt: "JM Roofing & Remodeling LLC team delivering exceptional construction and remodeling services in Brockton, MA.",
      width: 1200,
      height: 800,
    },
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Brockton, Massachusetts, 02301",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2948.532742013176!2d-71.01993668453343!3d42.08343397920564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e48404c9a6c5bb%3A0xabcdef123456789!2sBrockton%2C%20MA%2002301%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
        { 
            name: 'Apple Maps', 
            url: 'https://maps.apple.com/?address=Brockton,+MA+02301,+USA',
        },
        { 
            name: 'Bing Maps', 
            url: 'https://www.bing.com/maps?q=Brockton,+MA+02301,+USA&FORM=HDRSC6',
        },
        { 
            name: 'Google Earth', 
            url: 'https://earth.google.com/web/search/Brockton,+MA+02301,+USA/@42.083434,-71.019937,15a,814.57589625d,35y,0h,0t,0r',
        },
        { 
            name: 'Google Maps', 
            url: 'https://www.google.com/maps/place/Brockton,+MA+02301,+USA/@42.083434,-71.019937,15z',
        },
    ],  
  },
  contact: {
    sectionTitle: "Get in Touch with JM Roofing & Remodeling LLC",
    description: 
      "Enhance and protect your home with the expert services of JM Roofing & Remodeling LLC in Brockton, MA. Whether you need a roof installation, remodeling, or renovation services, our skilled team is here to deliver exceptional craftsmanship and reliable solutions. Contact us today to schedule a consultation or request a free estimate. Let’s bring your vision to life!",
    socialLinks: {
      facebook: redirectLink,     
      instagram: redirectLink,     
      twitter: redirectLink,     
      linkedin: redirectLink,     
      youtube: redirectLink,     
    },
    contactNumbers: [
      "Mobile: (774) 240-6752",
    ],
    logo: bizIcon,
    emailRecipient: "info@jmroofingremodelingllc.com"
  },
  footer: {
    bizSolutionsLogo: myBizIcon
  }
};


